import { SET_SCROLL_DISTANCE } from '../actionConstants';

export const setScrollDistanceAction = (payload) => {
  return {
    type: SET_SCROLL_DISTANCE,
    payload,
  };
};
